import { useEffect, useState } from 'react';

import { CLICK_TO_BUY } from 'constants/clickToBuy';

export function useC2BAdditionalProductsPermission({
    noSellItems = [],
    skus = [],
    totalEmployeeCount,
    type,
}) {
    const [hasPermission, setHasPermission] = useState(false);
    const [loading, setLoading] = useState(true);
    const [companyHasAssureHireSKU, setCompanyHasAssureHireSKU] = useState(false);
    const [companyHasTrakstarPerformSKU, setCompanyHasTrakstarPerformSKU] = useState(true);
    const [companyHasTrackerI9SKU, setCompanyHasTrackerI9SKU] = useState(false);

    useEffect(() => {
        function setPermission() {
            const companyHasAssureHireSKU = skus => {
                return CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.ASSURE_HIRE.SKU_KEYS.every(
                    skuKey => skus.some(({ key }) => key === skuKey)
                );
            };
            const hasAssureHireSKU = companyHasAssureHireSKU(skus);

            const getLicenseCodesAsStrings = items =>
                items.flatMap(({ licenseCodes }) => licenseCodes.map(code => code.toString()));

            const noSellLicenseCodes = getLicenseCodesAsStrings(noSellItems);

            const hasAssureHireSKUInNoSellList = CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.ASSURE_HIRE.LICENSE_CODES.every(
                licenseCode => noSellLicenseCodes.includes(licenseCode.toString())
            );

            const companyHasTrakstarPerformSKU = skus => {
                return CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TRAKSTAR_PERFORM.SKU_KEYS.every(
                    skuKey => skus.some(({ key }) => key === skuKey)
                );
            };
            const hasTrakstarPerformSKU = companyHasTrakstarPerformSKU(skus);
            const hasTrakstarPerformSKUInNoSellList = CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TRAKSTAR_PERFORM.LICENSE_CODES.every(
                licenseCode => noSellLicenseCodes.includes(licenseCode.toString())
            );

            const companyHasTrackerI9SKU = skus => {
                return CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TRACKER_I9.SKU_KEYS.every(
                    skuKey => skus.some(({ key }) => key === skuKey)
                );
            };
            const hasTrackerI9SKU = companyHasTrackerI9SKU(skus);
            const hasTrackerI9SKUInNoSellList = CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TRACKER_I9.LICENSE_CODES.every(
                licenseCode => noSellLicenseCodes.includes(licenseCode.toString())
            );

            let hasValidPermissions = false;
            if (type === CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TYPES.ASSURE_HIRE) {
                hasValidPermissions = !hasAssureHireSKUInNoSellList && !hasAssureHireSKU;
            } else if (
                type === CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TYPES.TRAKSTAR_PERFORM
            ) {
                hasValidPermissions =
                    !hasTrakstarPerformSKUInNoSellList &&
                    !hasTrakstarPerformSKU &&
                    totalEmployeeCount >=
                        CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TRAKSTAR_PERFORM
                            .MIN_EMPLOYEE_COUNT;
            } else if (type === CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TYPES.TRACKER_I9) {
                hasValidPermissions =
                    !hasTrackerI9SKUInNoSellList &&
                    !hasTrackerI9SKU &&
                    totalEmployeeCount >=
                        CLICK_TO_BUY.MARKET_PLACE.PRODUCTS.ADDITIONAL.TRACKER_I9.MIN_EMPLOYEE_COUNT;
            }

            setHasPermission(hasValidPermissions);
            setCompanyHasAssureHireSKU(hasAssureHireSKU);
            setCompanyHasTrakstarPerformSKU(hasTrakstarPerformSKU);
            setCompanyHasTrackerI9SKU(hasTrackerI9SKU);
            setLoading(false);
        }

        setPermission();
    }, [noSellItems, skus, totalEmployeeCount, type]);

    return {
        companyHasAssureHireSKU,
        companyHasTrackerI9SKU,
        companyHasTrakstarPerformSKU,
        hasPermission,
        loading,
    };
}
